import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  FeaturePageImageApiPath,
  ListHistoriesResponse,
  ListMissingResponse,
  MissingImagePage,
  RunBatchResponse,
  SetImageVars,
  SiteIdVars
} from '@/common/api/params/featurePageImage'

/** 実行履歴（直近10世代・新しい順） */
export const useFeaturePageImageHistoriesApi = (vars: SiteIdVars) =>
  useSWR<ListHistoriesResponse, Response, [string, SiteIdVars]>(
    [FeaturePageImageApiPath.LIST_HISTORIES, vars],
    apiDefaultFetcher
  )

/** 手動保管が必要なページ（対象外のサイトでは 0 件が返る） */
export const useFeaturePageImageMissingApi = (vars: SiteIdVars) =>
  useSWR<ListMissingResponse, Response, [string, SiteIdVars]>(
    [FeaturePageImageApiPath.LIST_MISSING, vars],
    apiDefaultFetcher
  )

/** バッチの手動実行。動作は定時実行と同一で、実行中は 409 が返る */
export const useFeaturePageImageRunApi = (onSuccess?: (r: RunBatchResponse) => void) =>
  useCallMutation<RunBatchResponse, SiteIdVars>(FeaturePageImageApiPath.RUN_BATCH, { onSuccess })

/** 画像URLの手動登録 */
export const useFeaturePageImageSetApi = (onSuccess?: (r: MissingImagePage) => void) =>
  useCallMutation<MissingImagePage, SetImageVars>(
    FeaturePageImageApiPath.SET_IMAGE,
    { onSuccess },
    apiPutFetcher
  )
